import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { DcButton, PixelFactoryContext, PixelTable } from 'pixel-base'
import {
  getReconciliation,
  undoReconciliation,
} from 'utils/api-routes-accounts'
import FinancePageShell from '../../components/FinancePageShell'
import FinanceStatusBadge from '../../components/FinanceStatusBadge'
import { useFinanceObservable } from '../../hooks/useFinanceObservable'
import { Reconciliation } from '../../types/finance'
import formatFinanceDate from '../../utils/formatFinanceDate'

const ReconciliationDetail = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const pixelFactory = React.useContext(PixelFactoryContext) as any
  const reconciliation = useFinanceObservable<Reconciliation>(
    () => getReconciliation(id),
    { immediate: Boolean(id) },
  )
  const row = reconciliation.data

  const undo = () => {
    undoReconciliation(Number(id)).subscribe({
      next: () => {
        pixelFactory?.showSuccess?.('Reconciliation undone')
        navigate('/finance/reconciliation')
      },
      error: () => pixelFactory?.showFailure?.('Unable to undo reconciliation'),
    })
  }

  return (
    <FinancePageShell
      title={row ? `Reconciliation #${row.id}` : 'Reconciliation'}
      breadcrumbs={[
        { name: 'Finance', active: false },
        { name: 'Reconciliation', active: false },
        {
          name: row ? `Reconciliation #${row.id}` : 'Reconciliation',
          active: true,
        },
      ]}
      isLoading={reconciliation.loading}
    >
      {row && (
        <div style={{ display: 'grid', gap: 20 }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: 16,
            }}
          >
            <div>
              <strong>Type</strong>
              <div>{row.reconciliation_type}</div>
            </div>
            <div>
              <strong>Status</strong>
              <div>
                <FinanceStatusBadge status="reconciled" />
              </div>
            </div>
            <div>
              <strong>Created At</strong>
              <div>{formatFinanceDate(row.created_at)}</div>
            </div>
          </div>
          <PixelTable
            columns={[
              {
                name: 'Line ID',
                selector: (line) => line.journal_entry_line_id,
              },
              {
                name: 'Allocated Amount',
                selector: (line) => line.allocated_amount,
              },
            ]}
            data={row.lines || []}
            pagination
          />
          <DcButton variant="outline-danger" onClick={undo}>
            Undo Reconciliation
          </DcButton>
        </div>
      )}
    </FinancePageShell>
  )
}

export default ReconciliationDetail
